import styled from 'styled-components'
import { Button } from '@sketch/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding-right: 12px;

  /*
  We need to set the height for the tooltip the same as the action icons,
  otherwise, actions with tooltip will have a bigger height by default
  */
  .tooltip {
    height: 24px;
  }
`

export const Title = styled.div`
  width: 100%;
  height: 32px;
  padding: 9px 12px; /* stylelint-disable-line scales/space */
  margin: 0 8px;
  font-size: ${({ theme }) => theme.fontSizes.B};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-weight: 600;
  display: flex;
  display: inline-flex;
  user-select: none;
`

export const Action = styled(Button).attrs({
  size: '24',
})`
  display: inline-flex;
  cursor: pointer;
  outline: 0;
  border: 0;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`
